import { createApp } from 'vue'
import store from './store'
import router from './router'
import App from './App.vue'

import { DatePicker, Button, message, Modal, Tooltip } from 'ant-design-vue'
import 'ant-design-vue/dist/reset.css'

import './utils/polyfill'
import Clipboard from './utils/vue-clipboard'
import lazyImg from './utils/lazyImg'

import './permission'
import './style/index.scss'
import 'remixicon/fonts/remixicon.css'

import EhfIcon from './components/ehf-icon'
import EhfImageUpload from './components/ehf-image-upload'
import EhfImagePreview from './components/ehf-image-preview'
import EhfImageEditor from './components/ehf-image-editor'
import EhfSkuTable from './components/ehf-sku-table'
import EhfNoMore from './components/ehf-no-more'
import EhfEmojiList from './components/ehf-emoji-list'
import EhfEditor from './components/ehf-editor'
import EhfChart from './components/ehf-chart'
import EhfEmsInfo from './components/ehf-ems-info'
import EhfVideoUpload from './components/ehf-video-upload/index.vue'
import EhfExtImage from './components/ehf-ext-image/index.vue'
import EhfConfettiButton from './components/ehf-confetti-button/index.vue'
import EhfChatHistory from './components/ehf-chat-history/index.vue'
import EhfSplitPanel from './components/ehf-split-panel/index.vue'
import EhfActionSelect from './components/ehf-action-select/index.vue'
import EhfMenu from './components/ehf-menu'

import request from './utils/request'

import VMdEditor from '@kangc/v-md-editor'
import '@kangc/v-md-editor/lib/style/base-editor.css'
import VMdPreview from '@kangc/v-md-editor/lib/preview'
import '@kangc/v-md-editor/lib/style/preview.css'

import githubTheme from '@kangc/v-md-editor/lib/theme/github.js'
import '@kangc/v-md-editor/lib/theme/style/github.css'
import hljs from 'highlight.js'

VMdEditor.use(githubTheme, {
  Hljs: hljs,
})
VMdPreview.use(githubTheme, {
  Hljs: hljs,
})
// app.use(ElementPlus)
const app = createApp(App)
// v-auto-height 自适应文本框高度
const handleAutoHeight = (el) => {
  if (el.value !== '') {
    el.style.height = 'auto'
    // el.scrollTop = 0 //防抖动
    var _scrollHeight = el.scrollHeight
    el.style.height = _scrollHeight + 'px'
  } else {
    el.style.height = ''
  }
}
app.directive('auto-height', (el, binding) => {
  if (!binding.value) {
    return
  }
  if (binding.oldValue && binding.oldValue.previewMode !== undefined && binding.oldValue.previewMode !== binding.value.previewMode) {
    // 预览模式切换时延时
    setTimeout(() => {
      handleAutoHeight(el)
    }, 520)
  } else {
    handleAutoHeight(el)
  }
})

import NProgress from 'nprogress' // progress bar
NProgress.start()
request.get('/config.json?_=' + new Date().getTime()).then((res) => {
  const config = res
  localStorage.env_model = config.MODEL

  app.config.globalProperties.$WebConfig = config
  let https = '//'
  app.config.globalProperties.$HTTPS = https

  let apiUrl = process.env.NODE_ENV === 'development' ? '/api' : https + config.API_DOMAIN
  let sdkApiUrl = process.env.NODE_ENV === 'development' ? '/sdk' : https + config.SDK_DOMAIN
  let wxserverUrl = https + config.WXSERVER_DOMAIN
  let phpcrontabUrl = https + config.PHPCRONTAB_DOMAIN

  app.config.globalProperties.$WXSERVER_URL = wxserverUrl
  app.config.globalProperties.$PHPCRONTAB_URL = phpcrontabUrl
  app.config.globalProperties.$API_URL = apiUrl
  app.config.globalProperties.$SDK_API_URL = sdkApiUrl
  // 修改request的baseurl
  request.defaults.baseURL = apiUrl
  request.defaults.__webConfig = config // 通过请求方法缓存配置文件中的请求地址

  store.dispatch('settings/setWebConfig', config)
  store.dispatch('settings/setHttps', https)
  store.dispatch('settings/setAPIURL', apiUrl)
  store.dispatch('settings/setSDKAPIURL', sdkApiUrl)
  app.use(router)
  app.use(store)
  app.use(VMdPreview)
  app.use(VMdEditor)
  app.use(DatePicker).use(Button).use(Tooltip)
  app.use(Clipboard).use(lazyImg)
  app.component('ehf-icon', EhfIcon)
  app.component('ehf-image-upload', EhfImageUpload)
  app.component('ehf-image-preview', EhfImagePreview)
  app.component('ehf-image-editor', EhfImageEditor)
  app.component('ehf-sku-table', EhfSkuTable)
  app.component('ehf-no-more', EhfNoMore)
  app.component('ehf-emoji-list', EhfEmojiList)
  app.component('ehf-editor', EhfEditor)
  app.component('ehf-chart', EhfChart)
  app.component('ehf-ems-info', EhfEmsInfo)
  app.component('ehf-video-upload', EhfVideoUpload)
  app.component('ehf-ext-image', EhfExtImage)
  app.component('ehf-confetti-button', EhfConfettiButton)
  app.component('ehf-chat-history', EhfChatHistory)
  app.component('ehf-split-panel', EhfSplitPanel)
  app.component('ehf-action-select', EhfActionSelect)
  app.component('ehf-menu', EhfMenu)

  message.config({
    duration: 1, // 全局设置显示1秒
  })
  app.config.globalProperties.$message = message
  app.config.globalProperties.$modal = Modal

  app.mount('#app')
})

export default app
